import React, { useState, useEffect, useMemo } from "react";
import { Modal, FloatingLabel, Form } from "react-bootstrap";
import LoadingButton from "./LoadingButton.js";
import { useGlobalContext } from "./GlobalContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import NumberSpinner from "./NumberSpinner.js";
import { Timestamp } from "firebase/firestore";
import MotifStock from "./MotifStock.js";

function ModalArticle({
  show,
  currentArticleEdit,
  onHide,
  onValid,
  onCancel,
}) {
  const {
    db,
    user,
    handleShowConfirmation,
    handleCloseConfirmation,
    getPhotoArticle,
    resizeImage,
    TypeMotifStock,
    TypeMouvement,
    TailleHomme,
    TailleFemme,
    TailleEnfant,
  } = useGlobalContext();
  const [title, setTitle] = useState(
    currentArticleEdit ? currentArticleEdit.title : ""
  );
  const [description, setDescription] = useState(
    currentArticleEdit ? currentArticleEdit.description : ""
  );
  const [photoUrl, setPhotoUrl] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [qte, setQte] = useState(currentArticleEdit ? currentArticleEdit.qte : 0);
  const [stockVerified, setStockVerified] = useState(false);
  const [prix, setPrix] = useState("");
  const [prixDecimal, setPrixDecimal] = useState("");
  const [motifStock, setMotifStock] = useState("");
  const [withTaille, setWithTaille] = useState(currentArticleEdit ? currentArticleEdit.withTaille : false);
  const [withFlocageAvant, setWithFlocageAvant] = useState(currentArticleEdit ? currentArticleEdit.withFlocageAvant : false);
  const [visible, setVisible] = useState(currentArticleEdit ? currentArticleEdit.visible : false);
  const initQteTailleHomme = useMemo(() => {
    const retour = {};
    TailleHomme.map(t => retour["_" + t] = 0);
    return retour;
  }, [TailleHomme]);
  const initQteTailleFemme = useMemo(() => {
    const retour = {};
    TailleFemme.map(t => retour["_" + t] = 0);
    return retour;
  }, [TailleFemme]);
  const initQteTailleEnfant = useMemo(() => {
    const retour = {};
    TailleEnfant.map(t => retour["_" + t] = 0);
    return retour;
  }, [TailleEnfant]);
  const [qteTailleHommeObj, setQteTailleHommeObj] = useState(currentArticleEdit && withTaille && currentArticleEdit.qteTailleHomme ? JSON.parse(currentArticleEdit.qteTailleHomme) : initQteTailleHomme);
  const [qteTailleFemmeObj, setQteTailleFemmeObj] = useState(currentArticleEdit && withTaille && currentArticleEdit.qteTailleFemme ? JSON.parse(currentArticleEdit.qteTailleFemme) : initQteTailleFemme);
  const [qteTailleEnfantObj, setQteTailleEnfantObj] = useState(currentArticleEdit && withTaille && currentArticleEdit.qteTailleEnfant ? JSON.parse(currentArticleEdit.qteTailleEnfant) : initQteTailleEnfant);

  useEffect(() => {
    if (show) {
      if (currentArticleEdit) {
        setTitle(currentArticleEdit ? currentArticleEdit.title : "");
        setDescription(currentArticleEdit ? currentArticleEdit.description : "");
        const prixInter = currentArticleEdit ? currentArticleEdit.prix : 0;
        var partieEntiere = parseInt(prixInter);
        var partieDecimale = parseFloat((prixInter % 1).toFixed(2)) * 100;
        setPrix(partieEntiere);
        setPrixDecimal(partieDecimale);
        setPhoto(null);
        setPhotoUrl(currentArticleEdit ? currentArticleEdit.photoUrl : "");
        setQte(currentArticleEdit ? currentArticleEdit.qte : 0);
        setVisible(currentArticleEdit ? currentArticleEdit.visible : false);
        setWithTaille(currentArticleEdit ? currentArticleEdit.withTaille : false);
        setWithFlocageAvant(currentArticleEdit ? currentArticleEdit.withFlocageAvant : false);
        setQteTailleHommeObj(currentArticleEdit && currentArticleEdit.qteTailleHomme ? JSON.parse(currentArticleEdit.qteTailleHomme) : initQteTailleHomme)
        setQteTailleFemmeObj(currentArticleEdit && currentArticleEdit.qteTailleFemme ? JSON.parse(currentArticleEdit.qteTailleFemme) : initQteTailleFemme)
        setQteTailleEnfantObj(currentArticleEdit && currentArticleEdit.qteTailleEnfant ? JSON.parse(currentArticleEdit.qteTailleEnfant) : initQteTailleEnfant)
        setStockVerified(false);
      } else {
        setTitle("");
        setDescription("");
        setPrix("");
        setPrixDecimal("");
        setPhoto(null);
        setPhotoUrl(null);
        setQte(0);
        setWithTaille(false);
        setWithFlocageAvant(false);
        setVisible(false);
        setStockVerified(false);
      }
    }

  }, [currentArticleEdit, show, initQteTailleEnfant, initQteTailleHomme, initQteTailleFemme]);

  const handleAddArticle = async () => {
    try {
      const uid = "auto-generated" + Date.now();
      const prixFinal = (prix === "" ? 0 : parseInt(prix)) + (prixDecimal === "" ? 0 : (parseInt(prixDecimal) / 100));
      if (photo) {
        const resizedImageBlob = await resizeImage(photo, 1500); // Ajustez la taille souhaitée
        await db
          .addPhotoUrlArticle(uid, resizedImageBlob)
          .then(async (photoUrl) => {
            await db.addArticle({
              uid: uid,
              title,
              description,
              photoUrl: photoUrl,
              qte: qte,
              prix: prixFinal,
              mouvementStock: [],
              withTaille: withTaille,
              qteTailleHomme: JSON.stringify(qteTailleHommeObj),
              qteTailleFemme: JSON.stringify(qteTailleFemmeObj),
              qteTailleEnfant: JSON.stringify(qteTailleEnfantObj),
              visible: visible,
              withFlocageAvant: withFlocageAvant
            });
          })
          .catch((error) => {
            console.error("Upload impossible : ", error);
          });
      } else {
        await db.addArticle({
          uid: uid,
          title,
          description,
          photoUrl: null,
          qte: qte,
          prix: prixFinal,
          mouvementStock: [],
          withTaille: withTaille,
          qteTailleHomme: JSON.stringify(qteTailleHommeObj),
          qteTailleFemme: JSON.stringify(qteTailleFemmeObj),
          qteTailleEnfant: JSON.stringify(qteTailleEnfantObj),
          visible: visible,
          withFlocageAvant: withFlocageAvant
        });
      }
      onValid();
    } catch (error) {
      console.log("Error add article", error);
    }
  };

  const handleUpdateArticle = async () => {
    try {
      const prixFinal = (prix === "" ? 0 : parseInt(prix)) + (prixDecimal === "" ? 0 : (parseInt(prixDecimal) / 100));
      const tailleHommeObj = {};
      tailleHommeObj[TailleHomme.XS] = 0;

      const obj = {
        title,
        description,
        qte: qte,
        prix: prixFinal,
        withTaille: withTaille,
        qteTailleHomme: JSON.stringify(qteTailleHommeObj),
        qteTailleFemme: JSON.stringify(qteTailleFemmeObj),
        qteTailleEnfant: JSON.stringify(qteTailleEnfantObj),
        visible: visible,
        withFlocageAvant: withFlocageAvant
      }
      if (qte !== currentArticleEdit.qte || stockVerified) {
        let mouvementStock = currentArticleEdit.mouvementStock;
        mouvementStock.splice(0, 0, {
          "typeMouvement": qte - currentArticleEdit.qte >= 0 ? TypeMouvement.DEPOT : TypeMouvement.ACHAT,
          "qte": qte === currentArticleEdit.qte ? currentArticleEdit.qte : qte - currentArticleEdit.qte,
          "modifiedBy": user,
          "licencie": null,
          "date": Timestamp.now(),
          "motif": qte === currentArticleEdit.qte ? TypeMotifStock.VERIFICATION : motifStock
        });
        mouvementStock.map(m => {
          m["modifiedBy"] = m["modifiedBy"] ? m["modifiedBy"].uid : null;
          m["licencie"] = m["licencie"] ? m["licencie"].uid : null;
          return m;
        })
        obj["mouvementStock"] = mouvementStock;
      }
      if (currentArticleEdit.photoUrl === null && photo !== null) {
        await db.addPhotoUrlArticle(currentArticleEdit.uid, photo)
          .then(async (photoUrl) => {
            obj["photoUrl"] = photoUrl;
            await db.updateArticle(currentArticleEdit.uid, obj);
          })
      } else {
        await db.updateArticle(currentArticleEdit.uid, obj);
      }
      onValid();
    } catch (error) {
      console.log("Error edit article", error);
    }
  };

  const handleRemoveArticle = async () => {
    try {
      if (currentArticleEdit.photoUrl) {
        db.deletePhotoUrlArticle(currentArticleEdit).then(async () => {
          await db.removeArticle(currentArticleEdit.uid);
          currentArticleEdit.photoUrl = null;
        });
      } else {
        await db.removeArticle(currentArticleEdit.uid);
      }
    } catch (error) {
      console.log("Error Remove article", error);
    }
    onValid();
    handleCloseConfirmation();
  };

  const handleImageDelete = async () => {
    db.deletePhotoUrlArticle(currentArticleEdit)
      .then(async () => {
        currentArticleEdit.photoUrl = null;
        setPhotoUrl(null);
        handleCloseConfirmation();
      });
  };

  const handleImageChange = async (e) => {
    const photo = e.target.files[0];
    if (photo == null) return;
    try {
      setPhoto(photo);
    } catch (error) {
      console.log("Error imageChange", error);
    }
  };


  const handlePrixChange = (e) => {
    const inputValue = e.target.value;

    // Convertir la valeur en nombre
    const numericValue = parseInt(inputValue.replace(/[^0-9]/g, ''));

    // Valider la plage de valeurs
    const minValue = 0;
    const maxValue = 1000;

    if (numericValue < minValue || numericValue > maxValue || inputValue.length > 4) {
      // Gérer l'erreur, par exemple, afficher un message à l'utilisateur
      console.log("Montant hors de la plage autorisée");
      return;
    }

    setPrix(inputValue);
  };

  const handlePrixDecimalChange = (e) => {
    const inputValue = e.target.value;
    // Convertir la valeur en nombre
    const numericValue = parseFloat(inputValue);
    // Valider la plage de valeurs
    const minValue = 0;
    const maxValue = 99;

    if (numericValue < minValue || numericValue > maxValue || inputValue.length > 2) {
      // Gérer l'erreur, par exemple, afficher un message à l'utilisateur
      console.log("Montant hors de la plage autorisée");
      return;
    }

    setPrixDecimal(inputValue);
  };

  const handleKeyDown = (e) => {
    // Vérifier si le caractère n'est pas un chiffre
    if (!/\d/.test(e.key) && e.code !== "Backspace") {
      // Annuler la saisie en empêchant l'événement par défaut
      e.preventDefault();
    }
  };

  const setQteTaille = (type, curTaille, qte) => {
    if (type === "Homme") {
      qteTailleHommeObj["_" + curTaille] = qte;
      setQteTailleHommeObj(qteTailleHommeObj);
    } else if (type === "Femme") {
      qteTailleFemmeObj["_" + curTaille] = qte;
      setQteTailleFemmeObj(qteTailleFemmeObj);
    } else if (type === "Enfant") {
      qteTailleEnfantObj["_" + curTaille] = qte;
      setQteTailleEnfantObj(qteTailleEnfantObj);
    }
  }

  const manquePrix = prix === "" && prixDecimal === "";
  const manqueTitle = title === "";
  const manqueMotif = currentArticleEdit && qte !== currentArticleEdit.qte && motifStock === "";

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {currentArticleEdit
            ? "Modification d'un article"
            : "Ajout d'un article"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Form.Check
            type="checkbox"
            id="visibleId"
            label="Visible dans la boutique"
            checked={visible}
            onChange={(e) => {
              setVisible(e.target.checked);
            }}
          />

          <FloatingLabel
            label="Titre"
            className="mb-3"
            style={{ width: "100%" }}
          >
            <Form.Control
              type="text"
              style={{ width: "100%" }}
              autoComplete="on"
              value={title}
              required
              onChange={(e) => setTitle(e.target.value)}
              placeholder=""
            />
          </FloatingLabel>
          {manqueTitle && <span style={{ color: "darkorange", textAlign: "center", marginRight: "5px", marginBottom: "10px" }}>Veuillez indiquer le titre</span>}

          <div style={{ display: "flex", width: "100%", marginBottom: "20px", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {photoUrl === null ?
              <>
                <Form.Group controlId="formFile">
                  <Form.Label className="btn btn-custom1">
                    Sélectionner
                  </Form.Label>
                  <Form.Control
                    style={{ display: "none" }}
                    type="file"
                    onChange={handleImageChange}
                  />
                </Form.Group>

              </> :
              <LoadingButton
                className="btn btn-custom1"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                onClickPromise={async () => {
                  handleShowConfirmation(
                    "Voulez-vous enlever l'image ? ",
                    "Le reste des informations seront conservés",
                    "danger",
                    "Enlever",
                    "Annuler",
                    null,
                    handleImageDelete
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{
                    fontSize: "1em",
                    marginRight: "5px",
                    color: "red",
                  }}
                />
                Supprimer l'image
              </LoadingButton>
            }
            {photoUrl !== null ?
              getPhotoArticle(photoUrl, title, {
                maxHeight: "150px",
                maxWidth: "150px",
                height: "100%",
                width: "100%",
                borderRadius: "5px",
              })
              : photo !== null ?
                <span style={{ textAlign: "center", marginRight: "5px", marginBottom: "5px", marginLeft: "5px" }}>{photo.name}</span>
                :
                <span style={{ textAlign: "center", marginRight: "5px", marginBottom: "5px", marginLeft: "5px" }}>Aucune image</span>
            }
          </div>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>

            <Form.Check
              type="checkbox"
              id="taille"
              label="Avec taille"
              checked={withTaille}
              onChange={(e) => {
                setWithTaille(e.target.checked);
                console.log("setWithtaille" + e.target.checked)
              }}
            />
            {withTaille &&
              <Form.Check
                type="checkbox"
                id="flocageAvantId"
                label="Avec flocage avant"
                checked={withFlocageAvant}
                onChange={(e) => {
                  setWithFlocageAvant(e.target.checked);
                }}
              />}

          </div>

          {withTaille &&
            <div>
              <label style={{ backgroundColor: "#f0f0f0", padding: "5px", borderRadius: "3px" }}>Taille Homme</label>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                {TailleHomme.map((currentType, index) => {
                  return (
                    <div
                      key={index}
                      style={{ marginLeft: "10px", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "5px" }}
                    >
                      <label style={{ marginBottom: "10px" }}>{currentType}</label>
                      <NumberSpinner
                        minValue={0}
                        maxValue={1000}
                        firstValue={qteTailleHommeObj["_" + currentType]}
                        afterChangeValue={(nb) => setQteTaille("Homme", currentType, nb)}
                      ></NumberSpinner>
                    </div>
                  );
                })}
              </div>
              <label style={{ backgroundColor: "#f0f0f0", padding: "5px", borderRadius: "3px" }}>Taille Femme</label>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                {TailleFemme.map((currentType, index) => {
                  return (
                    <div
                      key={index}
                      style={{ marginLeft: "10px", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "5px" }}
                    >
                      <label style={{ marginBottom: "10px" }}>{currentType}</label>
                      <NumberSpinner
                        minValue={0}
                        maxValue={1000}
                        firstValue={qteTailleFemmeObj["_" + currentType]}
                        afterChangeValue={(nb) => setQteTaille("Femme", currentType, nb)}
                      ></NumberSpinner>
                    </div>
                  );
                })}
              </div>
              <label style={{ backgroundColor: "#f0f0f0", padding: "5px", borderRadius: "3px" }}>Taille Enfant</label>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                {TailleEnfant.map((currentType, index) => {
                  return (
                    <div
                      key={index}
                      style={{ marginLeft: "10px", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "5px" }}
                    >
                      <label style={{ marginBottom: "10px" }}>{currentType}</label>
                      <NumberSpinner
                        minValue={0}
                        maxValue={1000}
                        firstValue={qteTailleEnfantObj["_" + currentType]}
                        afterChangeValue={(nb) => setQteTaille("Enfant", currentType, nb)}
                      ></NumberSpinner>
                    </div>
                  );
                })}
              </div>
            </div>
          }

          <FloatingLabel controlId="floatingTextarea2" label="Description" style={{ width: "100%", marginTop: "10px" }}>
            <Form.Control
              className="mb-3"
              as="textarea"
              placeholder="Description"
              style={{ height: "150px" }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </FloatingLabel>
          <div
            style={{ display: "flex", width: "100%", alignItems: "center", marginBottom: "5px", marginTop: "10px" }}
          >
            {(!withTaille && qte !== null && currentArticleEdit !== null && qte === currentArticleEdit.qte) ?
              <Form.Check
                style={{ width: "100%" }}
                type="checkbox"
                id="keyPass"
                label="J'ai vérifié le stock"
                checked={stockVerified}
                onChange={(e) => {
                  setStockVerified(e.target.checked);
                }}
              />
              : !withTaille && qte !== null && currentArticleEdit !== null ?
                <div style={{ display: "flex", flexDirection: "column", flex: "1 1 auto", width: "100%" }}>
                  {qte - currentArticleEdit.qte > 0 ?
                    <span style={{ width: "100%", fontWeight: "bold", textAlign: "right" }}>{qte - currentArticleEdit.qte} de plus</span>
                    :
                    <span style={{ width: "100%", fontWeight: "bold", textAlign: "right", color: "darkred" }}>{(qte - currentArticleEdit.qte) * (-1)} de moins</span>
                  }
                  <span style={{ marginBottom: "5px", marginLeft: "5px", color: "green" }}>Motif changement de stock</span>
                  <MotifStock
                    ecart={qte - currentArticleEdit.qte}
                    motif={motifStock}
                    setMotifStock={setMotifStock}
                  >
                  </MotifStock>
                  {manqueMotif && <span style={{ color: "darkorange", textAlign: "center", marginRight: "5px", marginBottom: "10px" }}>Veuillez indiquer le motif</span>}
                </div>
                : null
            }

            {!withTaille &&
              <div
                style={{ marginLeft: "10px", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "5px" }}
              >
                <label style={{ marginBottom: "10px" }}>Stock</label>
                <NumberSpinner
                  minValue={0}
                  maxValue={1000}
                  firstValue={qte}
                  afterChangeValue={(nb) => setQte(nb)}
                ></NumberSpinner>
              </div>
            }

          </div>

          <div
            style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center", marginBottom: "5px" }}
          >
            <label style={{ marginBottom: "10px" }}>Prix</label>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", fontSize: "2em" }}>
              <input
                type="number"
                min="0"
                max="1000"
                step="1"
                placeholder="0"
                style={{ borderRadius: "5px", border: "1px solid gray", padding: "10px", marginRight: "5px", marginBottom: "5px", width: "100px", height: "50px", textAlign: "center", lineHeight: "1em", fontSize: "1em", fontWeight: "400" }}
                value={prix}
                required
                onChange={(e) => handlePrixChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              ,
              <input
                type="number"
                min="0"
                max="1000"
                step="1"
                placeholder="00"
                style={{ borderRadius: "5px", border: "1px solid gray", padding: "10px", marginLeft: "10px", marginBottom: "5px", width: "70px", height: "50px", textAlign: "center", lineHeight: "1em", fontSize: "1em", fontWeight: "400" }}
                value={prixDecimal}
                required
                onChange={(e) => handlePrixDecimalChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
              />
            </div>
            {manquePrix && <span style={{ color: "darkorange", textAlign: "center", marginRight: "5px", marginBottom: "10px" }}>Veuillez indiquer le prix</span>}
          </div>

        </Form>

      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {currentArticleEdit ? (
              <LoadingButton
                className="btn btn-custom5"
                disabled={user && currentArticleEdit && user.uid === currentArticleEdit.uid}
                onClick={() => {
                  handleShowConfirmation(
                    "Supprimer cet article ?",
                    "",
                    "danger",
                    "Supprimer",
                    "Annuler",
                    handleRemoveArticle
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ fontSize: "1em", marginRight: "5px", color: "red" }}
                />
                Supprimer
              </LoadingButton>
            ) : null}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <LoadingButton className="btn btn-custom1" onClick={onCancel}>
              Annuler
            </LoadingButton>
            <LoadingButton
              className="btn btn-custom2"
              disabled={
                manqueTitle || (manqueMotif && !withTaille) || manquePrix
              }
              onClickPromise={
                currentArticleEdit ? handleUpdateArticle : handleAddArticle
              }
            >

              {currentArticleEdit ? "Enregistrer" : "Ajouter"}
            </LoadingButton>
          </div>
        </div>
      </Modal.Footer>
    </Modal >
  );
}

export default ModalArticle;
